import React, { memo } from 'react';
import { FadeIn } from '../ui/FadeIn';
const steps = [{
  num: '01',
  title: 'Descargue el material',
  desc: 'Reciba el acceso inmediato en su correo tras la compra.'
}, {
  num: '02',
  title: 'Aplique el Método V.I.S.A.',
  desc: 'Dedique 15 minutos cada mañana a los ejercicios de neuro-activación.'
}, {
  num: '03',
  title: 'Viva con claridad',
  desc: "Note como el 'vaho' mental desaparece y la confianza en su memoria regresa."
}];
export function HowItWorks() {
  return <section className="bg-navy-900 py-24 md:py-32 px-6 text-cream-50" data-id="element-107">
      <div className="max-w-5xl mx-auto" data-id="element-108">
        <FadeIn data-id="element-109">
          <div className="text-center mb-20" data-id="element-110">
            <h2 className="font-serif text-3xl md:text-4xl font-bold mb-4" data-id="element-111">
              Cómo funciona
            </h2>
            <div className="w-16 h-1 bg-gold-400 mx-auto rounded-full" data-id="element-112"></div>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-12 md:gap-8 relative" data-id="element-113">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-1/6 right-1/6 h-0.5 bg-navy-800 z-0" data-id="element-114"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="relative z-10" data-id="element-115">
              <div className="flex flex-col items-center text-center" data-id="element-116">
                <div className="w-24 h-24 rounded-full bg-navy-800 border-2 border-gold-500 flex items-center justify-center mb-8 shadow-[0_0_30px_rgba(201,162,74,0.15)]" data-id="element-117">
                  <span className="font-serif text-3xl text-gold-400 font-bold" data-id="element-118">
                    {step.num}
                  </span>
                </div>
                <h3 className="text-2xl font-bold mb-4 text-cream-50" data-id="element-119">
                  {step.title}
                </h3>
                <p className="text-lg text-cream-100/80 leading-relaxed" data-id="element-120">
                  {step.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}